import * as ActionTypes from "constants/ActionTypes";

export const hideCuepointPreviews = () => ({
  type: ActionTypes.HIDE_CUEPOINT_PREVIEWS,
});

export const setVisibleCuepointPreviewIndex = (index) => ({
  index,
  type: ActionTypes.SET_VISIBLE_CUEPOINT_PREVIEW_INDEX,
});
